import { USER_ROLES } from '../common/constants';
import { SuperAdminDashboard, OrgAdminDashboard, InstructorDashboard, StudentDashboard } from '../components/dashboard';
import { BlockLoading } from '../components/Loading';
import { useAuthStore } from '../store/authStore';

const DashboardPage: React.FC = () => {
    const { user } = useAuthStore();

    if (!user) {
        return (
            <div className="flex items-center justify-center h-96">
                <BlockLoading text="Loading dashboard..." />
            </div>
        );
    }

    switch (user.role) {
        case USER_ROLES.SUPER_ADMIN:
            return <SuperAdminDashboard />;

        case USER_ROLES.ORG_ADMIN:
            return <OrgAdminDashboard />;

        case USER_ROLES.ORG_INSTRUCTOR:
        case USER_ROLES.ORG_MODERATOR:
            return <InstructorDashboard />;

        case USER_ROLES.ORG_MEMBER:
        case USER_ROLES.INDIVIDUAL_USER:
        default:
            return <StudentDashboard />;
    }
};

export default DashboardPage;
